import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Avatar,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function GroupMembersDialog({ open, onClose, members }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      //   sx={{ "& .MuiDialog-paper": { maxWidth: "427px !important" } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: "bold",
        }}
      >
        Group Members
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          "&::-webkit-scrollbar": { display: "none" },

          padding: "unset",
        }}
      >
        <Typography variant="subtitle1" mx={3} my={2} fontWeight="bold">
          All Active Staff ({members.length} Members)
        </Typography>

        <List>
          {members.map((member, index) => (
            <React.Fragment key={index}>
              <ListItem sx={{ paddingX: "20px" }}>
                <ListItemAvatar>
                  <Avatar sx={{ width: 40, height: 40 }}>
                    {member?.name
                      ?.split(" ")
                      .map((word, index) => {
                        if (
                          index === 0 ||
                          index === member?.name.split(" ").length - 1
                        ) {
                          return word.charAt(0);
                        }
                        return null;
                      })
                      .join("")}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={member.name}
                  secondary={member.email}
                  primaryTypographyProps={{ fontWeight: "bold" }}
                />
              </ListItem>
              {index < members.length - 1 && <Divider component="li" />}
            </React.Fragment>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
}

export default GroupMembersDialog;
